<template>
  <span :style="{color: params.value == 'Успех' ? '#2cc185' : '#e30c0c'}">{{params.value}}</span>
</template>
